import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule, ActivatedRoute } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TableModule, TableLazyLoadEvent } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ActivityTypeService } from '../activity-type.service';
import { ActivityType } from '../activity-type.model';
import { Page } from '../../../models/page-wrapper.model';

@Component({
  selector: 'app-list-activity-type',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TableModule,
    ButtonModule,
    ToastModule,
    ConfirmDialogModule,
  ],
  templateUrl: './list-activity-type.component.html',
  styleUrl: './list-activity-type.component.css',
  providers: [ConfirmationService, MessageService],
})

export class ListActivityTypeComponent implements OnInit {
  activityType: ActivityType[] = [];
  totalRecords = 0;
  isLoading = true;

  constructor(
    private route: ActivatedRoute,
    private activityTypeService: ActivityTypeService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.loadActivityTypes();
    // Initial load is handled by the p-table's onLazyLoad event
  }

  loadActivityTypes(event?: TableLazyLoadEvent) {
    this.isLoading = true;

    const size = event?.rows ?? 10;
    const page = event?.first ? Math.floor(event.first / size) : 0;

    const params: any = {
      page,
      size,
    };
    this.activityTypeService.getAllActivityTypes(params).subscribe({
      next: (page: Page<ActivityType>) => {
        this.activityType = page.content || [];
        this.totalRecords = page.totalElements;
        this.isLoading = false;

      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load Activity Type.',
        });
        console.error(err);
        this.isLoading = false;
      },
    });
  }

  createActivityType(): void {
    this.router.navigate(
      ['.', { outlets: { canvasOutlet: ['activity-types', 'create'] } }],
      { relativeTo: this.route.parent?.parent }
    );
  }

  editActivityType(id: number): void {
    this.router.navigate([
      '/ai-studio/session/current',
      { outlets: { canvasOutlet: ['activity-types', 'edit', id] } },
    ]);
  }

  deleteActivityType(activityType : ActivityType): void {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this activity-type?',
      header: 'Confirm Deletion',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Yes, Delete',
      rejectLabel: 'Cancel',

      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-success',

      accept: () => {
        this.activityTypeService.deleteActivityType(activityType.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: `ActivityType Deleted successfully.`,
            });
            setTimeout(() => {
              this.loadActivityTypes();
            }, 500);
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: `Failed to Delete activity-type.`,
            });
            console.error(err);
          },
        });
      },
    });
  }
}
